/**
 * Normaliza um texto para comparação sem acento, tudo maiúsculo,
 * substituindo caracteres especiais por espaço.
 */
export function normalizarTexto(s) {
  return String(s || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
